<sh-toast-container [toasts]="toasts$ | async" (closeToast)="closeToast($event)"></sh-toast-container>
